<template>
  <v-container class="screen2">
    <v-layout row wrap>
      <gallery :images="images" :index="index" @close="index = null"></gallery>
      <v-flex xs4
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
      >
        <v-img class="gallery-img"
          aspect-ratio="1.33"
          @click="index = imageIndex"
          :style="{backgroundImage: 'url(' + image + ')'}">
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import VueGallery from 'vue-gallery'

  export default {
    data: function () {
      return {
        images: [
          '/static/img/gallery/malina/1.jpg',
          '/static/img/gallery/malina/2.jpg',
          '/static/img/gallery/malina/3.jpg',
          '/static/img/gallery/malina/4.jpg',
          '/static/img/gallery/malina/5.jpg',
          '/static/img/gallery/malina/6.jpg',
          '/static/img/gallery/malina/7.jpg',
          '/static/img/gallery/malina/8.jpg',
          '/static/img/gallery/malina/9.jpg'
        ],
        index: null
      }
    },
    components: {
      'gallery': VueGallery
    }
  }
</script>

<style scoped>
.gallery-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gallery-img:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/screens/malina/Gallery.vue